import React from "react";
import "./ProjectTile.css";
import { Tag } from "Pieces/Tag";
import { useNavigate } from "react-router-dom";
import { ProjectTileType } from "types";
import { Fade } from "motion";
import { Text } from "foundation";
import { Flex } from "@chakra-ui/react";
import { responsivePadding } from "Outlets/MainOutlet";

interface Props {
  project: ProjectTileType;
  index: number;
}

export const ProjectTile: React.FC<Props> = ({ project, index }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/${project.type[0]}/${project.key}`);
  };

  return (
    <Flex
      width={{ base: "100%", sm: "50%", md: `${100 / 3}%` }}
      borderRight="1px solid black"
      borderTop="1px solid black"
    >
      <Fade stagger={index}>
        <div
          className={`project_tile__image project_tile__image-${project.type[0]} clickable`}
          onClick={handleClick}
        >
          {project.cover ? (
            <img src={project.cover} alt={project.title} />
          ) : (
            <></>
          )}
        </div>
        <Flex
          direction="column"
          gap="0.5rem"
          padding={{ base: "1rem", sm: "1.5rem", md: "2rem" }}
        >
          <Flex direction="column" gap="0.25rem">
            <Text textStyle="h4">{project.client}</Text>
            <Text textStyle="h3" onClick={handleClick} className="clickable">
              {project.title}
            </Text>
          </Flex>
          <div className="project_tile__tags">
            {project.tags.map((tag, index) => (
              <Tag name={tag} key={index} />
            ))}
          </div>
        </Flex>
      </Fade>
    </Flex>
  );
};

export default ProjectTile;
